module.exports = __webpack_public_path__ + "img/game1.45b39cbb.png";